import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {RoutingService} from '@app/service/routing/routing.service';
import {LoggerService} from '@app/service/logger/logger.service';
import {
  GoogleLogin,
  LoginSuccess,
  LoginFailure
} from '@shared/state/auth/auth.actions';
import {Actions, ofActionCompleted, Store} from '@ngxs/store';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss', './../auth.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  messages: string[];
  returnUrl: string;
  loading = false;
  redirectLink: string = '';

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private route: ActivatedRoute, private logger: LoggerService,
              private routingService: RoutingService, private store: Store,
              private activatedRoute: ActivatedRoute, private actions: Actions) {
    this.messages = [];
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/explore';
  }

  ngOnInit(): void {
    this.resolveNavParams();

    this.actions.pipe(ofActionCompleted(LoginSuccess, LoginFailure))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  resolveNavParams() {
    this.activatedRoute.queryParams
      .pipe(take(1))
      .subscribe(params => {
        if (!params) {
          return;
        }
        const redirectLink = params['redirectTo'];
        if (redirectLink) {
          this.redirectLink = redirectLink;
        }
      });
  }

  loginWithGoogle() {
    this.loading = true;
    this.store.dispatch(new GoogleLogin({
      linkType: 'login',
      redirectLink: this.redirectLink
    }));
  }
}
